import { useUser } from 'contexts/UserContext'
import { useEffect } from 'react'
import { useLocation } from 'wouter'

export default function Logout() {
  const { setUser } = useUser()
  const [, setLocation] = useLocation()

  useEffect(() => {
    // Limpieza local
    setUser(null)

    if (document.body.classList.contains('dark')) {
      document.body.classList.remove('dark')
    }

    // Redirigir a login
    setLocation('/login')
  }, [setUser, setLocation])

  return null
}
